import {
	API_ADMIN_GET_ALL_TUBELIBRARY,
	API_ADMIN_GET_TUBELIBRARY,
	ADMIN_RESET_FOCUS_TUBELIBRARY,
    API_GET_ALL_TUBELIBRARY,
} from '../actions/tubeLibrary';

export function adminGetTubeLibrary(tubeLibrary) {
	return {
		type: API_ADMIN_GET_TUBELIBRARY,
		payload: {
			request: {
				url: `/admin/tubesLibrary/${tubeLibrary.id}`,
			},
		},
	};
}

export function adminGetAllTubeLibrary() {
	return {
		type: API_ADMIN_GET_ALL_TUBELIBRARY,
		payload: {
			request: {
				url: `/admin/tubesLibrary`,
			},
		},
	};
}

export function getAllTubeLibrary() {
	return {
		type: API_GET_ALL_TUBELIBRARY,
		payload: {
			request: {
				url: `/tubesLibrary`,
			},
		},
	};
}

export function resetFocusTubeLibrary() {
	return {
		type: ADMIN_RESET_FOCUS_TUBELIBRARY,
	};
}
